<div class="main-wrapper">
  <span class="header1" *ngIf="projectName.length > 0">Selected Project</span>
  <div class="field-wrapper" *ngIf="projectName.length > 0">
    <span class="label">Project Name</span>
    <span class="fieldval">{{ projectName }}</span>
  </div>
  <div class="system-wrapper" *ngIf="projectName.length > 0">
    <span class="label">System</span>
    <span class="fieldval">{{
      this.projectService.isMetricUnit ? "Metirc" : "Imperial"
    }}</span>
  </div>
  <div class="lang-wrapper" *ngIf="projectName.length > 0">
    <span class="label">Language</span>
    <span class="fieldval">{{ this.projectService.selectedLang }}</span>
  </div>

  <span class="header2">Project Upload</span>
  <div class="system">
    <span class="label">System</span>
    <input
      type="radio"
      id="met"
      name="sys"
      [value]="true"
      [(ngModel)]="this.projectService.toUpload_isMetricUnit"
    />
    <label for="age1">Metirc</label><br />
    <input
      type="radio"
      id="imp"
      name="sys"
      [value]="false"
      [(ngModel)]="this.projectService.toUpload_isMetricUnit"
    />
    <label for="age2">Imperial</label><br />
  </div>
  <button (click)="onFileInput()">
    {{ file ? file.name : "Upload Zip" }}
  </button>
</div>
